var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "page-header",
        {
          attrs: {
            title: _vm.$t("pages.admin.users.title"),
            "icon-class": "mdi mdi-account-group"
          }
        },
        [_c("div", { staticClass: "text-right" })]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 grid-margin stretch-card" },
          [
            _c("user-filter", {
              attrs: { filter: _vm.filter },
              on: {
                "update:filter": function($event) {
                  _vm.filter = $event
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card shadow-sm" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("static-loading-indicator-icon", {
              attrs: { loading: _vm.$store.getters.shouldLoadLocal }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "table-responsive" }, [
              _c(
                "table",
                { staticClass: "table table-striped table-borderless" },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v("Name")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Subscribed")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Health")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Referral Partner")]),
                      _vm._v(" "),
                      _c("th", [_vm._v(_vm._s(_vm.$t("actions.actions")))])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.paginationData.data, function(user) {
                      return _c("tr", [
                        _c("td", { class: { blocked: user.blocked } }, [
                          user.is_admin
                            ? _c("i", {
                                staticClass:
                                  " mdi mdi-18px mdi-shield-account float-left pr-1"
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n                                " +
                              _vm._s(user.first_name) +
                              "\n                                " +
                              _vm._s(user.last_name) +
                              "\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          user.is_subscribed
                            ? _c(
                                "span",
                                { staticClass: "badge badge-success" },
                                [_c("i", { staticClass: "mdi mdi-check" })]
                              )
                            : _c(
                                "span",
                                { staticClass: "badge badge-danger" },
                                [_c("i", { staticClass: "mdi mdi-close" })]
                              )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("i", {
                            staticClass: "mdi mdi-heart",
                            class: [
                              {
                                "text-danger":
                                  user.question_answers &&
                                  _vm.hasHealthProblem(user.question_answers),
                                "text-secondary": user.question_answers === null
                              },
                              "text-primary"
                            ]
                          })
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                user.referrer_partner === null
                                  ? ""
                                  : user.referrer_partner.partner
                              ) +
                              "\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "btn btn-outline-primary btn-sm",
                                attrs: {
                                  tag: "button",
                                  to: {
                                    name: "admin.user.info",
                                    params: { user: user.id }
                                  }
                                }
                              },
                              [_c("i", { staticClass: "mdi mdi-eye" })]
                            ),
                            _vm._v(" "),
                            !user.blocked && !user.is_admin
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-outline-danger btn-sm float-right ",
                                    on: {
                                      click: function($event) {
                                        _vm.selectedUser = user
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "mdi mdi-lock" })]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            user.blocked
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-outline-info btn-sm float-right ",
                                    on: {
                                      click: function($event) {
                                        return _vm.unblockUser(user.id)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "mdi mdi-lock-open"
                                    })
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-3" },
                [
                  _c("pagination", {
                    attrs: { data: _vm.paginationData },
                    on: { "pagination-change-page": _vm.getUsers }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("user-block-modal", {
              attrs: { selected: _vm.selectedUser },
              on: {
                "user-blocked": _vm.onUserBlocked,
                "modal-close": function($event) {
                  _vm.selectedUser = null
                }
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }